import React, { useEffect, useState } from 'react'
import { Button, Menu } from '@material-ui/core'
import { currencyFormat } from '../../../Product/common/components'
import AuthContext from '../../../Product/context/auth/authContext'

const ProductContainer = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [savingPercent, setSavingPercent] = React.useState(0)
    const [averageSavings, setAverageSavings] = React.useState(0)
    const authContext = React.useContext(AuthContext)
    const { saveSearch, user } = authContext
    const trackData = props.data.product
    let handleAsinSearch
    const handleShareClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleShareClose = () => {
        setAnchorEl(null)
    }
    // const calculateAvgSavings = (trackData) => {
    //     if (!trackData) return 0
    //     const retailPrice = parseFloat(trackData?.mprice)
    //     const auctionPrice = parseFloat(trackData?.wprice)
    //     const buyNowPrice = parseFloat(trackData?.bprice)

    //     const savings = retailPrice - (trackData?.buynow == 1 ? buyNowPrice : auctionPrice)
    //     const avgSavings = (savings / retailPrice) * 100
    //     return avgSavings.toFixed(2)
    // }
    useEffect(() => {
        if (props.data?.product) {
            const retailPrice = parseFloat(props.data?.product?.mprice)
            const auctionPrice = parseFloat(props.data?.product?.wprice)
            const buyNowPrice = parseFloat(props.data?.product?.bprice)

            const savings =
                retailPrice - (props.data?.product?.buynow == 1 ? buyNowPrice : auctionPrice)
            const avgSavings = (savings / retailPrice) * 100
            console.log('savings', savings)
            console.log('avgSavings', avgSavings)
            setAverageSavings(savings.toFixed(2))
            setSavingPercent(avgSavings.toFixed(2))
        }
    }, [props.data?.product])
    // const handleAsinSearch = useCallback(() => {
    //     if (!selectedProduct) return

    //     const query =
    //         selectedProduct.asin && selectedProduct.asin != 0
    //             ? selectedProduct.asin
    //             : selectedProduct.title
    //     window.open(
    //         `https://www.google.com/search?q=${encodeURIComponent(query)}`,
    //         '_blank',
    //         'noopener,noreferrer',
    //     )
    //     if (window.dataLayer) {
    //         dataLayer.push({
    //             event: 'eventTracking',
    //             category: 'asset listing',
    //             action: 'research online',
    //             label: 'outbound',
    //         })
    //     }
    // }, [selectedProduct?.asin, selectedProduct?.title])

    const socialMenuList = [
        {
            name: 'Text Message',
            link: 'sms:',
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle h-4 w-4"
                >
                    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                </svg>
            ),
        },
        {
            name: 'Facebook',
            link: 'https://www.facebook.com/sharer/sharer.php?u=',
            icon: (
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"></path>
                </svg>
            ),
        },
        {
            name: 'instagram',
            link: 'https://www.instagram.com/',
            icon: (
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path>
                </svg>
            ),
        },
        {
            name: 'TikTok',
            link: 'https://www.tiktok.com/',
            icon: (
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"></path>
                </svg>
            ),
        },
    ]
    console.log('trackData', trackData)
    const handleAlert = () => {
        if (user?.id) {
            saveSearch({
                searchbar: trackData?.title || '',
            })
        }
    }
    return (
        <>
            <div className="productRoundOuterContaienr">
                <div className="productGridContainer">
                    <div className="productimageBox">
                        <a href="#" className="proName">
                            {trackData?.brand_name}
                        </a>
                        <picture className="proImgtag">
                            <img
                                src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}${
                                    global.storeConfigration?.image_compression?.value == 1
                                        ? 'thumb_'
                                        : ''
                                }${trackData?.avatar}`}
                                className="Image"
                                onError={(e) =>
                                    (e.target.src = `${global?.storeDetails?.logoValue}`)
                                }
                            />
                        </picture>
                    </div>
                    <div className="productDetailsBox">
                        <div className="productDetailsTopList">
                            <a href="" onClick={handleAsinSearch}></a>
                            <Button className="shareBtn" onClick={handleShareClick}>
                                <i className="material-icons-outlined">share</i>
                                Share
                            </Button>
                            <Menu
                                id="customized-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleShareClose}
                                elevation={0}
                                getContentAnchorEl={null} // 🔥 IMPORTANT FIX
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                className="socialMenuclass"
                            >
                                {socialMenuList.map((menuItem, index) => (
                                    <div
                                        className="listMenu"
                                        onClick={() => window.open(menuItem.link, '_blank')}
                                        key={index}
                                    >
                                        {menuItem.icon}
                                        {menuItem.name}
                                    </div>
                                ))}
                            </Menu>
                        </div>
                        <div className="d-flex">
                            <h1 className="text-center proTititle">{trackData?.title}</h1>
                        </div>
                        <div className="productMarketIfo">
                            <div className="text-center retailInfo">
                                <p className="rpt">Retail Price</p>
                                <p className="rp">
                                    {currencyFormat(parseFloat(trackData?.mprice).toFixed(2))}
                                </p>
                            </div>
                            <div className="offerInfo">
                                <i className="material-icons-outlined">trending_down</i>
                                <div className="text-center">
                                    <p className="as">Avg. Savings</p>
                                    <p className="asv">
                                        {' '}
                                        {currencyFormat(parseFloat(averageSavings).toFixed(2))} {''}
                                        ({savingPercent}%)
                                    </p>
                                </div>
                            </div>
                            <div className="productAlert">
                                <h3 className="text-center pat">Product Alerts</h3>
                                <div className="notifyFlexBox">
                                    <p className="notyTxt">
                                        Get notified when new auctions start or prices drop below
                                        your target
                                    </p>
                                    <Button className="setAlertBtn" onClick={handleAlert}>
                                        <i className="material-icons-outlined">
                                            notifications_none
                                        </i>
                                        Set Alert
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductContainer
